"use client";

import { Grid2 } from "@repo/ui";
import Section from "../components/Section";
import CategoryCard from "@/components/CategoryCard";
import { getImageProps } from "next/image";
import { getBackgroundImage } from "@/lib/helpers";

type WhyChooseSpoclearnProps = {
  sectionInfo: PageSections;
  data?: {
    heading?: string;
    backgroundImagePath?: string;
    cards?: {
      icon?: string;
      label: string;
      text?: string;
      color: "blue" | "gray" | "rose";
    }[];
  };
};
export default function WhyChooseSpoclearn({
  data,
  sectionInfo,
}: WhyChooseSpoclearnProps) {
  const cardColor = {
    blue: "bg-[linear-gradient(127deg,_#FFF_0%,_#E0F1FC_71.61%)]",
    gray: "bg-[linear-gradient(311deg,_#DBE4F0_0%,_#FFF_90.84%)]",
    rose: "bg-[linear-gradient(127deg,_#FFF_0%,_#FCF8F9_71.61%)]",
  };

  const {
    props: { srcSet },
  } = getImageProps({
    alt: "",
    width: 1500,
    height: 468,
    quality: 100,
    src: data?.backgroundImagePath || "",
  });
  const backgroundImage = getBackgroundImage(srcSet);
  const style = { backgroundImage };

  return (
    <Section
      title={data?.heading}
      style={style}
      className={`${sectionInfo.sectionClass} bg-no-repeat bg-cover bg-center text-white`}
      id={sectionInfo?.sectionId}
    >
      <Grid2 container spacing={5}>
        {data?.cards?.map((card, index) => (
          <Grid2
            size={{ sm: 6, md: 4, lg: 4 }}
            key={`why-choose-us-spoclearn-card-${index}`}
          >
            <CategoryCard
              title={card?.label}
              description={card?.text}
              icon={card?.icon}
              isContentType
              className={`!text-black ${cardColor[card?.color]}`}
            />
          </Grid2>
        ))}
      </Grid2>
    </Section>
  );
}
